import { connect } from 'react-redux'
import { unsetModal } from '../actions/modal-actions'
import SameIssuesHistory from '../components/SameIssuesHistory'
import { getElementIdField } from '../helpers/element'

const mapStateToProps = (state) => {
  const { elements: currentComponents } = state.componentState
  const componentStates = state.loggingState.componentStates

  const componentCounts = {}
  const componentLastFaultAt = {}
  currentComponents.forEach((component) => {
    const id = component[getElementIdField(component)]
    const componentState = componentStates[id] || {}
    componentCounts[id] = componentState.faultLogCount || 0
    componentLastFaultAt[id] = componentState.lastFaultAt || null
  })

  const componentsWithHistory = currentComponents
    .filter(
      (component) =>
        componentCounts[component[getElementIdField(component)]] > 0,
    )
    .sort((a, b) => {
      const idA = componentLastFaultAt[a[getElementIdField(a)]] || 0
      const idB = componentLastFaultAt[b[getElementIdField(b)]] || 0
      // Latest fault first (Unix ms timestamp), falling back to fault count
      // for ties/missing timestamps.
      return (
        idB - idA ||
        componentCounts[b[getElementIdField(b)]] -
          componentCounts[a[getElementIdField(a)]]
      )
    })

  return {
    isOpen: state.modalState.isOpen,
    components: componentsWithHistory,
    componentCounts,
    componentFaultHistories: state.loggingState.componentFaultHistories,
    componentFaultHistoriesLoading:
      state.loggingState.componentFaultHistoriesLoading,
    makeModelId: state.componentState.makeModelId,
    vin: state.componentState.vin,
    vehicleTestResultId: state.componentState.vehicleTestResultId,
  }
}

export { mapStateToProps }

const mapDispatchToProps = (dispatch) => {
  return {
    onClose: () => {
      dispatch(unsetModal())
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SameIssuesHistory)
